import { CURRENCIES } from "./data";
import type { Currency } from "./types";

export function getCurrencyName(code: Currency): string {
	const name = CURRENCIES.find((item) => item.value === code)?.longName;

	return name || "deviza";
}
